const DEFAULT_API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export function resolveAssetUrl(path?: string | null): string | undefined {
  if (!path) return undefined;
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${DEFAULT_API_BASE}${normalizedPath}`;
}
